import {
  Typography,
  Box,
  Card,
  CardContent,
} from "@mui/material";
import Slider from "react-slick";

export default function Feedbacks() {
  const testimonials = [
    {
      name: "Amit Sharma",
      role: "Product Manager",
      rating: 5,
      message:
        "The experience was outstanding. Clean UI, fast delivery, and excellent communication.",
    },
    {
      name: "Neha Verma",
      role: "Startup Founder",
      rating: 5,
      message:
        "Very professional team. Our product quality improved significantly.",
    },
    {
      name: "Rahul Singh",
      role: "CTO",
      rating: 4,
      message:
        "Strong technical expertise and reliable support throughout the project.",
    },
  ];

  const sliderSettings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  return (
    <Box className="py-5">
      <div className="container">
      <div className="row gy-5">
        {/* LEFT SIDE */}
        <div className="col-12 col-md-6">
          <Typography variant="subtitle1" className="text-primary fw-bold">
            Testimonials
          </Typography>

          <Typography
            variant="h4"
            className="fw-bold mt-2"
            sx={{ lineHeight: 1.2 }}
          >
            Here is What Our Customers Say
          </Typography>

          <Typography className="mt-2 text-secondary" sx={{ maxWidth: 500 }}>
            Discover a life-changing experience via experts that are highly
            recommend.
          </Typography>
        </div>

        {/* RIGHT SIDE */}
        <div className="col-12 col-md-6 d-flex align-items-center">
          <Box
            className="p-4 rounded-4 w-100"
          >
            <Slider {...sliderSettings}>
              {testimonials.map((item, index) => (
                <Box key={index} px={2}>
                  <Card
                    sx={{
                      borderRadius: 4,
                      transition: "all 0.3s ease",
                      "&:hover": {
                        transform: "translateY(-6px)",
                      },
                    }}
                  >
                    <CardContent sx={{ p: 4 }}>
                      {/* Quote */}
                      <Typography
                        sx={{
                          position: "relative",
                          fontSize: "1.05rem",
                          lineHeight: 1.7,
                          color: "text.secondary",
                          pl: 3,
                        }}
                      >
                        <Box
                          component="span"
                          sx={{
                            position: "absolute",
                            left: 0,
                            top: -12,
                            fontSize: "3rem",
                            color: "primary.main",
                            fontWeight: 700,
                            opacity: 0.2,
                          }}
                        >
                          “
                        </Box>
                        {item.message}
                      </Typography>

                      {/* User Info */}
                      <Box mt={3}>
                        <Typography fontWeight={600}>
                          {item.name}
                        </Typography>
                        <Typography
                          variant="body2"
                          color="text.secondary"
                        >
                          {item.role}
                        </Typography>
                      </Box>
                    </CardContent>
                  </Card>
                </Box>
              ))}
            </Slider>
          </Box>
        </div>
      </div>
      </div>
    </Box>
  );
}
